import { MakeCall } from '../createMakeCall';
import { FavoriteUnitType } from '../types/inventory/FavoriteUnitType';

export type AddFavoriteUnitTypeCall = (
  unitTypeId: number,
) => Promise<{ data: FavoriteUnitType }>;

const addFavoriteUnitType = (makeCall: MakeCall) => (unitTypeId: number) =>
  makeCall<undefined>('POST', `/api/v2/unit-type/${unitTypeId}/favorite`);
export { addFavoriteUnitType };
